import {HttpClient, HttpEvent, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { defaultHeaders } from '../../../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(public httpClient: HttpClient) { }

  private get_<T>(actionUrl: any, options?: any): Observable<any> {
    return this.httpClient.get<T>(getUrlString(actionUrl), options).pipe(
      map((response: HttpEvent<T>) => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  private post_<T>(actionUrl: any, request: T, options?: any): Observable<any> {
    return this.httpClient.post<T>(getUrlString(actionUrl), request, options as any).pipe(
      map((response: HttpEvent<T>) => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  private put_<T>(actionUrl: any, request: any, options?: any): Observable<any> {
    return this.httpClient.put<T>(getUrlString(actionUrl), request, options as any).pipe(
      map((response: HttpEvent<T>) => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  private delete_<T>(actionUrl: any, options?: any): Observable<any> {
    return this.httpClient.delete<T>(getUrlString(actionUrl), options).pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }



  public get<T>(actionUrl: any, queryParams:{[key:string]: any} = {}, options?: any, headerType: keyof typeof defaultHeaders = 'allHeader'): Observable<any> {
    const headers = new HttpHeaders((options?.headers || {}))
    const mergedHeaders = {
      ...defaultHeaders[headerType].keys().reduce((acc: any, key: any) => ({ ...acc, [key]: defaultHeaders[headerType].get(key) }), {}),
      ...headers.keys().reduce((acc: any, key: any) => ({ ...acc, [key]: headers.get(key) }), {})
    }

    let params = new HttpParams();

    for (let key in queryParams) {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        params = params.set(key, `${queryParams[key]}`);
      }
    }

    return this.get_<T>(actionUrl, {
      ...options,
      params,
      headers
      // headers: new HttpHeaders(mergedHeaders)
    });
  }

  public post<T>(actionUrl: any, request: T, options:any = {}, headerType: keyof typeof defaultHeaders = 'allHeader'): Observable<any> {
    const headers = new HttpHeaders((options?.headers || {}));

    return this.post_<T>(actionUrl, request, {
      ...options,
      headers
    });
  }

  public postFormData<T>(actionUrl: any, request: T, options:any = {}): Observable<any> {
    const headers = new HttpHeaders((options?.headers || {}))

    return this.post_<T>(actionUrl, request, { ...options, headers });
  }

  public put<T>(actionUrl: any, request: T, options:any = {}, headerType: keyof typeof defaultHeaders = 'allHeader'): Observable<any> {
    const headers = new HttpHeaders((options?.headers || {}))
    const mergedHeaders = {
      ...defaultHeaders[headerType].keys().reduce((acc: any, key: any) => ({ ...acc, [key]: defaultHeaders[headerType].get(key) }), {}),
      ...headers.keys().reduce((acc: any, key: any) => ({ ...acc, [key]: headers.get(key) }), {})
    }

    return this.put_(actionUrl, request, {
      ...options,
      headers
      // headers: new HttpHeaders(mergedHeaders)
    });
  }

  public delete<T>(actionUrl: any, queryParams:{[key:string]: any} = {}, options?: any, headerType: keyof typeof defaultHeaders = 'allHeader'): Observable<any> {
    const headers = new HttpHeaders((options?.headers || {}))
    const mergedHeaders = {
      ...defaultHeaders[headerType].keys().reduce((acc: any, key: any) => ({ ...acc, [key]: defaultHeaders[headerType].get(key) }), {}),
      ...headers.keys().reduce((acc: any, key: any) => ({ ...acc, [key]: headers.get(key) }), {})
    }

    let params = new HttpParams();

    for (let key in queryParams) {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        params = params.set(key, `${queryParams[key]}`);
      }
    }

    return this.delete_<T>(actionUrl, {
      ...options,
      params,
      headers: new HttpHeaders(mergedHeaders)
    });
  }

  public downloadFile(actionUrl: any): Observable<any> {
    return this.get(`${environment.fileApiUrl}${actionUrl}`, undefined, { responseType: 'blob' });
  }

  public downloadFilePdf(url: string, filename: string) {
    this.downloadFile_(url, filename, 'application/pdf');
  }

  public downloadFileExcel(url: string, filename: string) {
    this.downloadFile_(url, filename, 'application/octet-stream');
  }

  public downloadFile_(url: string, filename: string, fileType: string) {
    // this.downloadFile(url).subscribe(response => {
    //     // It is necessary to create a new blob object with mime-type explicitly set
    //     // otherwise only Chrome works like it should
    //     var newBlob = new Blob([response], { type: fileType });

    //     // IE doesn't allow using a blob object directly as link href
    //     // instead it is necessary to use msSaveOrOpenBlob
    //     // if (window.navigator) {
    //         Utils.saveBlob(newBlob, filename);
    //         return;
    //    // }

    //     // For other browsers:
    //     // Create a link pointing to the ObjectURL containing the blob.
    //     // const data = window.URL.createObjectURL(newBlob);
    //     // var link = document.createElement('a');
    //     // link.href = data;
    //     // link.download = filename;
    //     //
    //     // // this is necessary as link.click() does not work on the latest firefox
    //     // link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    //     // setTimeout(() => {
    //     //     // For Firefox it is necessary to delay revoking the ObjectURL
    //     //     window.URL.revokeObjectURL(data);
    //     //     link.remove();
    //     // }, 100);
    // });
  }

  public getFile<T>(actionUrl: any, queryParams:{[key:string]: any} = {}, options?: any): Observable<any>{
    const headers = new HttpHeaders((options?.headers || {}))

    let params = new HttpParams();

    for (let key in queryParams) {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        params = params.set(key, `${queryParams[key]}`);
      }
    }

    return this.get_<T>(actionUrl, {
      ...options,
      params,
      responseType: 'blob',
      headers: headers
    });
  }

  public get baseURL(): string {
    return environment.baseURL;
  }

}

/**
 * Constructs the full API URL by prepending the appropriate base URL.
 *
 * @param url The partial API endpoint (e.g., '/api/auth/login').
 * @returns The complete, environment-specific URL.
 */
export function getUrlString(url: string): string {
  // 1. If route starts with a http already, just return as is.
  if (url.startsWith('http')) {
    return url;
  }

  // 2. Normalize the incoming URL to ensure it starts with a slash.
  const actionUrl = url.startsWith('/') ? url : `/${url}`;

  // 3. Define all routing rules in a single configuration array.
  //    Order can matter if prefixes are similar. Place more specific routes first.
  const urlMappings = [
    // Pre-Authentication & Public
    // { prefixes: ['/api/auth/', '/api/public/user/', '/api/post-payment'], baseUrl: environment.preApiUrl },

    // Wildcard for other "pre" endpoints
    { prefixes: ['/{pre}'], baseUrl: (environment.icrpURL + environment.apiBaseURL), isWildcard: true },

    // Wildcard for other "post" endpoints
    { prefixes: ['/{post}'], baseUrl: (environment.icrpURL + environment.apiBaseURL), isWildcard: true },

    // V1 Endpoints
    // { prefixes: ['/api/v1/name_suggestion'], baseUrl: environment.nameSuggestionApiUrl },
    // { prefixes: ['/api/v1/name_reservation', '/api/v1/registration', '/api/v1/application', '/api/v1/company_admin', '/api/v1/business_name_registration', '/api/v1/consent_code'], baseUrl: environment.nameReservationApiUrl },
    // { prefixes: ['/api/v1/auth', '/api/v1/mfa', '/api/v1/user', '/api/v1/back_office/jwt'], baseUrl: environment.authBaseURL },
    // { prefixes: ['/api/v1/stamp-duty'], baseUrl: environment.stampDutyServiceUrl },
    // { prefixes: ['/api/v1/dashboard-statistics'], baseUrl: environment.statsBaseURL },
    // { prefixes: ['/api/v1/public/tin'], baseUrl: environment.tinServiceUrl },

    // New Post Endpoints
    // { prefixes: ['/api/crp-bn-post'], baseUrl: environment.postBnApiUrl },

    // Other Endpoints
    // { prefixes: ['/api/business_name', '/api/public_search'], baseUrl: environment.nameSimilarityApiUrl },
    // { prefixes: ['/api/crp/ai'], baseUrl: environment.vasNameSimilarityApiUrl },
    { prefixes: ['/api'], baseUrl: environment.apiBaseURL },
  ];

  // 4. Find the first matching rule and construct the URL.
  for (const mapping of urlMappings) {
    const matchedPrefix = mapping.prefixes.find(prefix => actionUrl.startsWith(prefix));

    if (matchedPrefix) {
      // For the special wildcard, strip the prefix before prepending the base URL.
      if (mapping.isWildcard) {
        const finalUrl = actionUrl.replace(matchedPrefix, '');
        return `${mapping.baseUrl}${finalUrl}`;
      }
      // For all standard routes, simply prepend the base URL.
      return `${mapping.baseUrl}${actionUrl}`;
    }
  }

  // 5. If no specific rule matches, return the normalized URL as a fallback.
  return actionUrl;
}
